import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';  
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { ApiAuth } from 'app/domain/api';
import { ApiResponse, UserDTO } from 'app/domain/auth.model';


@Injectable({providedIn: 'root'})
export class AppUserService  { 

  constructor(private http: HttpClient) { }

  private _users: BehaviorSubject<UserDTO[] | null> = new BehaviorSubject<UserDTO[] | null>(null);
  
  get users$(): Observable<UserDTO[] | null> {
    return this._users.asObservable();
  }

  getAll(): Observable<UserDTO[]> {
    return this.http.get<UserDTO[]>(ApiAuth.Users).pipe(
        tap((users) => {
            this._users.next(users);
        })
    );
  } 

  



  public load() : Observable<UserDTO[]> {
    return this.http.get<UserDTO[]>(ApiAuth.Users);
  }
 
  public save(dto : UserDTO) : Observable<ApiResponse> {
    if(!dto.id)
      return this.http.post<ApiResponse>(ApiAuth.Users, dto);
    else
      return this.http.put<ApiResponse>(ApiAuth.Users, dto);
  }

  public delete(code : string) : Observable<ApiResponse> {
    return this.http.delete<ApiResponse>(ApiAuth.Users + "/" + code);
  }
 
}
